import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { APP_CONFIG } from './app/config/app-config';
import { ServiceWorkerService } from './app/core/services/service-worker.service';


if (environment.prodMode) {
  enableProdMode();
}

fetch('/assets/config/app-config.json')
.then((response) => response.json())
.then((appConfig) => {

  platformBrowserDynamic(
    [{ provide: APP_CONFIG, useValue: appConfig }]
  ).bootstrapModule(AppModule)
    .then((moduleRef) => {
      if ('serviceWorker' in navigator) {
        moduleRef.injector.get(ServiceWorkerService).registerMsDrive()
          .then(registration => registration?.update()
            .then(update => console.debug('[drive-sync] ServiceWorker updated successful: ', update),
              err => console.error('[drive-sync] ServiceWorker update failed: ', err)));
      }
    })
    .catch(err => console.error(err));
})
